import { useQuery } from '@tanstack/react-query'
import VideoTalentCard from './components/VideoTalentCard/VideoTalentCard'
import { listOfVideoTalentsFromMaster } from '../../../services/HutritClub'
import VideoTalentCardSkeleton from './components/VideoTalentCard/VideoTalentCardSkeleton'
import useResize from '../../../hooks/useResize'
import { ITEMS_PER_PAGE, VIEWPORT_LG } from '../../../utils/constants'
import { useState } from 'react'
import Pagination from '../../../components/Pagination'

const ListOfVideoTalents = ({ tabBarValue }) => {
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const [page, setPage] = useState(0)

  const {
    data: listOfVideoTalentsFromMasterData,
    isLoading: isLoadinglistOfVideoTalentsFromMasterData,
  } = useQuery(['list-video-talents-from-master', tabBarValue, page], () =>
    listOfVideoTalentsFromMaster({
      page,
      visible: tabBarValue === 'Aprobados',
      rejected: tabBarValue === 'Rechazados',
    })
  )

  if (isLoadinglistOfVideoTalentsFromMasterData)
    return <VideoTalentCardSkeleton />

  return (
    <div className="d-flex flex-column justify-content-center align-items-center align-items-lg-start">
      <div
        className={`${
          isMobile
            ? 'd-flex flex-column align-items-center gap-2'
            : 'tm-talent-container gap-4'
        }`}
      >
        {listOfVideoTalentsFromMasterData?.list?.map(
          ({ id, talent, url, visible = false, rejected = false }) => (
            <VideoTalentCard
              key={id}
              category="Ciber Seguridad"
              status={visible ? 'active' : 'desactivate'}
              statusName={
                visible ? 'Activado' : rejected ? 'Rechazado' : 'Sin validar'
              }
              username={talent?.user?.username}
              videoUrl={url}
              talentId={talent?.id}
              videoId={id}
            />
          )
        )}
      </div>
      <div
        style={{
          width: '600px',
        }}
      >
        <Pagination
          className="pt-2 pt-lg-5"
          page={page}
          setPage={setPage}
          itemsPerPage={ITEMS_PER_PAGE}
          totalItems={listOfVideoTalentsFromMasterData?.count}
        />
      </div>
    </div>
  )
}

export default ListOfVideoTalents
